import { ChecklistSubitem } from "../../types/checklist/types";
import Avaliacao from "./SubitemTypes/Avaliacao";
import Cep from "./SubitemTypes/Cep";
import Generico from "./SubitemTypes/Generico";
import Hora from "./SubitemTypes/Hora";
import ListaDeTextos from "./SubitemTypes/ListaDeTextos";
import Placa from "./SubitemTypes/Placa";
import TipoData from "./SubitemTypes/TipoData";
import UnicoMultiplo from "./SubitemTypes/UnicoMultiplo";
import ValorMedida from "./SubitemTypes/ValorMedida";



type props = {
  subitem: ChecklistSubitem;
  itemId: string;
  indexSubitem: number
};
export default function SubitemTypes({ subitem, itemId, indexSubitem }: props) {

  function inputByType(tipo: string) {
    switch (tipo) {
      case 'avaliacao': return (<Avaliacao subitem={subitem} itemId={itemId} indexSubitem={indexSubitem} />);
      case 'unique': case 'multiple': return (<UnicoMultiplo subitem={subitem} indexSubitem={indexSubitem} itemId={itemId} />);
      case 'list': return (<ListaDeTextos subitem={subitem} indexSubitem={indexSubitem} itemId={itemId} />);
      case 'data': return (<TipoData subitem={subitem} indexSubitem={indexSubitem} itemId={itemId} />);
      case 'hora': return (<Hora subitem={subitem} indexSubitem={indexSubitem} itemId={itemId} />);
      case 'valorMedida': return (<ValorMedida subitem={subitem} indexSubitem={indexSubitem} itemId={itemId} />);
      case 'placa': return (<Placa subitem={subitem} indexSubitem={indexSubitem} itemId={itemId} />);
      case 'cep': return (<Cep subitem={subitem} indexSubitem={indexSubitem} itemId={itemId} />);
      case 'textoCurto':
      case 'textoLongo':
      case 'telefone':
      case 'rg':
      case 'cpfcnpj':
      case 'numero':
      case 'email':
        return (<Generico subitem={subitem} indexSubitem={indexSubitem} itemId={itemId} />);
    }
  }
  return (
    <>
      {inputByType(subitem.tipo)}
    </>
  );
}
